// Reusable unit toggle (cm/in, kg/lb, etc.) used by the macros calculator and the evaluation form.
export const UnitToggle = ({ value, onChange, options, testid }) => (
  <div className="inline-flex border border-as-border" role="group" data-testid={testid}>
    {options.map((o) => (
      <button
        key={o.v}
        type="button"
        onClick={() => onChange(o.v)}
        className={`px-3 text-xs font-bold tracking-wider transition-colors ${
          value === o.v
            ? "bg-as-green text-as-black"
            : "bg-transparent text-as-gray hover:text-white"
        }`}
        data-testid={`${testid}-${o.v}`}
      >
        {o.l}
      </button>
    ))}
  </div>
);

// Conversion helpers — exact factors per NIST
export const toCm = (val, unit) => (unit === "in" ? Number(val) * 2.54 : Number(val));
export const toKg = (val, unit) => (unit === "lb" ? Number(val) * 0.45359237 : Number(val));
